import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${() => css`
    max-width: 85.5rem;
    margin: 2rem auto;
    padding: 4rem;

    > p {
      margin-top: 2rem;
    }
  `}
`;
